import Theory from "./theory";

export default Theory;